import {graphql, useLazyLoadQuery} from 'react-relay'

import type {useMyProfileQuery} from './__generated__/useMyProfileQuery.graphql'

const query = graphql`
  query useMyProfileQuery {
    user(userLocator: "current") {
      name
      username
      email
    }
  }
`

export default function useMyProfile() {
  const {user} = useLazyLoadQuery<useMyProfileQuery>(query, {})
  return user
}
